<router-outlet></router-outlet>
<app-automation-drift-warning></app-automation-drift-warning>
